import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Checkmark, Cross, Missing } from './icons';

export interface ToastProps {
  message: string;
  severity?: 'success' | 'error' | 'info';
  onClose?: () => void;
}

const borderColor = { success: '#079455', error: '#FC4D2B', info: '#01ADEF' };

export function Toast({ message, severity = 'info', onClose }: ToastProps) {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        color: 'text.primary',
        px: 1.5,
        py: 2,
        borderLeft: `2px solid ${borderColor[severity]}`,
        boxShadow: '0px 4px 16px 0px rgba(0,0,0,0.16)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        minWidth: 320,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {severity === 'success' && <Checkmark sx={{ width: 16, height: 16, color: borderColor.success }} />}
        {severity === 'error' && <Missing sx={{ width: 16, height: 16, color: borderColor.error }} />}
        <Typography component="span" fontSize={14} fontWeight={500} lineHeight={1.4}>
          {message}
        </Typography>
      </Box>
      {onClose && (
        <IconButton size="small" onClick={onClose} aria-label="close">
          <Cross stroke="#01ADEF" sx={{ width: 16, height: 16 }} />
        </IconButton>
      )}
    </Box>
  );
}
